<template lang="pug">
div
  .d-flex.justify-content-between.align-items-center.match-detail-function(v-if="![40, 41, 42, 43, 47].includes(sportsType)")
    .function-bar
      .tab-wrapper
        .nav-pills-wrapper
          ul#pills-tab.nav.nav-pills(
            v-if="((source.marketId == 3 && [1,20].includes(sportsType)) || source.marketId != 3)"
            role='tablist'
          )
            li.nav-item(v-if="isDetailsTotal || isChild2")
              a.nav-link(
                :class="{ 'active' : mode == 0 }"
                href="javascript:void(0);"
                @click="goToTab(0)"
              ) {{ $t("ui.main") }}
            li.nav-item(v-if="isChild1 && checkTabMode3")
              a.nav-link(
                :class="{ 'active' : mode == 3 }"
                href="javascript:void(0);"
                @click="goToTab(3)"
              ) {{ $t("ui.corners") }}
            li.nav-item(v-if="isChild2 && sportsType == 1 && checkTabMode4")
              a.nav-link(
                :class="{ 'active' : mode == 4 }"
                href="javascript:void(0);"
                @click="goToTab(4)"
              ) {{ $t("ui.specials") }}
      .function-item-more(:class="{ 'livetv' : source.marketId == 3 && source.channelId}")
        .btn-favorite(v-if="source.marketId == 3 && source.channelId" @click="popupTV(source)")
          i.fa.fa-tv.pt-1
        .btn-favorite(@click="toggleFavorite()")
          img(src='/images/favorite-active.svg?v=12')
        .btn-sm.btn-collapse.open-all(@click="toggleAll()")
  .tab-content(:id="'content-' + id")
    .tab-pane.accordion-all-leagues.active(:id="'accordian-more-' + id")
      template(v-if="![40, 41, 42, 43, 47].includes(sportsType)")
        template(v-if="[0].includes(mode)")
          template(v-if="(mmoDetails['hdp'] != null && checkOdds(mmoDetails['hdp'], 0) == true) || (mmoDetails['ou'] != null && checkOdds(mmoDetails['ou'], 0) == true)")
            moreHDPOUMMOX(:source="source")
        template(v-if="[3].includes(mode) && [1].includes(sportsType)")
          template(v-for="(sitem, skey) in child1Ids" v-if="isDataMMOEmptyModeMore(hdpou(sitem[0]))")
            moreHDPOUMMO1X(:source="hdpou(sitem[0])" :childId="sitem[0]")
        template(v-if="[4].includes(mode) && [1].includes(sportsType)")
          template(v-for="(sitem, skey) in child2Ids" v-if="isDataMMOEmptyModeMore(hdpou(sitem[0]))")
            moreHDPOUMMO1X(:source="hdpou(sitem[0])" :childId="sitem[0]")
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import moreHDPOUMMOX from "@/components/mobile/main/more/moreHDPOUMMOX";
import moreHDPOUMMO1X from "@/components/mobile/main/more/moreHDPOUMMO1X";

export default {
  components: {
    moreHDPOUMMOX,
    moreHDPOUMMO1X
  },
  mixins: [mixinHDPOUOdds],
  props: {
    child1Ids: {
      type: Array
    },
    child2Ids: {
      type: Array
    }
  },
  data() {
    return {
      mode: 0,
      emode: 101,
      win: []
    };
  },
  computed: {
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    isDetailsTotal() {
      return this.moreItems.total > 0;
    },
    isDetailsFull() {
      return this.moreItems.full > 0;
    },
    isDetailsHalf() {
      return this.moreItems.half > 0;
    },
    isChild1() {
      return this.child1Ids ? this.child1Ids.length > 0 : false;
    },
    isChild2() {
      return this.child2Ids ? this.child2Ids.length > 0 : false;
    },
    checkTabMode3() {
      var flag = false;
      this.child1Ids.forEach((v, k) => {
        if (this.isDataEmptyModeMore(this.hdpou(v[0]))) {
          flag = true;
        }
      });
      return flag;
    },
    checkTabMode4() {
      var flag = false;
      this.child2Ids.forEach((v, k) => {
        if (this.isDataEmptyModeMore(this.hdpou(v[0]))) {
          flag = true;
        }
      });
      return flag;
    }
  },
  mounted() {
    // var scroll1 = document.querySelector("#pills-tab .nav-item a.active");
    // scroll1.scrollIntoView({
    //   inline: "center"
    // });
  },
  methods: {
    toggleAll() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        elem.removeClass("close-all");
        elem.addClass("open-all");
        setTimeout(() => {
          // $(".collapse").collapse("show");
          $(".collapse").addClass("show");
          $(".collapse-more").removeClass("collapsed").attr("aria-expanded", "true");
        }, 100);
      } else {
        elem.removeClass("open-all");
        elem.addClass("close-all");
        setTimeout(() => {
          // $(".collapse").collapse("hide");
          $(".collapse").removeClass("show");
          $(".collapse-more").addClass("collapsed").attr("aria-expanded", "false");
        }, 100);
      }
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      // var elem = $(".btn-collapse");
      // if (elem.hasClass("close-all")) {
      //   elem.removeClass("close-all");
      //   elem.addClass("open-all");
      // }
      this.$store.dispatch("layout/resetSelectLeague");
    },
    toggleFavorite() {
      if (this.menu0 != "favorite") {
        this.resetSelectLeague();
        this.clearSearch();
        var mi5 = {};
        mi5["menuX"] = false;
        mi5["menuY"] = "0";
        mi5["menu0"] = "favorite";
        mi5["menu1"] = "today";
        mi5["menu3"] = "hdpou";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      } else {
        this.resetSelectLeague();
        this.clearSearch();
        var mi5 = {};
        mi5["menuX"] = false;
        mi5["menuY"] = "0";
        mi5["menu0"] = "all";
        mi5["menu1"] = "today";
        mi5["menu3"] = "hdpou";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
      this.$router.push("/prematch").catch(err => {});
    },
    isDataEmptyModeMore(details) {
      var hdp = details["hdp"] != null && details["hdp"][0] != null;
      var hdph = details["hdph"] != null && details["hdph"][0] != null;
      var ou = details["ou"] != null && details["ou"][0] != null;
      var ouh = details["ouh"] != null && details["ouh"][0] != null;
      var oxt = details["oxt"] != null && details["oxt"][0] != null;
      var oxth = details["oxth"] != null && details["oxth"][0] != null;
      var oe = details["oe"] != null && details["oe"][0] != null;
      var oeh = details["oeh"] != null && details["oeh"][0] != null;
      var ml = details["ml"] != null && details["ml"][0] != null;
      var mlh = details["mlh"] != null && details["mlh"][0] != null;
      return hdp || ou || oe || oxt || hdph || ouh || oxth || oeh || ml || mlh;
    },
    isDataMMOEmptyModeMore(details) {
      var hdp = details["mmo"]["hdp"] != null && details["mmo"]["hdp"][0] != null;
      var hdph = details["mmo"]["hdph"] != null && details["mmo"]["hdph"][0] != null;
      var ou = details["mmo"]["ou"] != null && details["mmo"]["ou"][0] != null;
      var ouh = details["mmo"]["ouh"] != null && details["mmo"]["ouh"][0] != null;
      return hdp || ou || hdph || ouh;
    },
    handleDefaultTab() {
      switch (this.mode) {
        case 0:
          if (this.details.total <= 0) {
            if (this.child1Ids.length > 0) {
              this.goToTab(3);
            } else {
              if (this.child2Ids.length > 0) {
                this.goToTab(0);
              }
            }
          }
          break;
        case 1:
          if (this.details.full <= 0) {
            this.goToTab(0);
          }
          break;
        case 2:
          if (this.details.half <= 0) {
            this.goToTab(0);
          }
          break;
        case 3:
          if (this.child1Ids.length <= 0) {
            this.goToTab(0);
          }
          break;
        case 4:
          if (this.child2Ids.length <= 0) {
            this.goToTab(0);
          }
          break;
      }

      if ([20, 40, 41, 42, 43, 47].includes(this.sportsType)) {
        var done = false;
        if (this.child2Ids) {
          this.child2Ids.forEach((v, k) => {
            if (!done) {
              this.emode = v[2];
              done = true;
            }
            return false;
          });
        }
        this.goToTab(this.emode);
      }
    },
    setDefaultTab() {
      this.handleDefaultTab();
    },
    league() {
      return this.$store.getters.data.league;
    },
    head() {
      return this.$store.getters.data.head;
    },
    match() {
      return this.$store.getters.data.match;
    },
    odds() {
      if (this.$store.getters.data.hasOwnProperty("odds")) {
        if (this.$store.getters.data.odds[this.layoutIndex] != null) {
          return this.$store.getters.data.odds[this.layoutIndex];
        } else {
          return {};
        }
      }
      return {};
    },
    mmo() {
      if (this.$store.getters.data.hasOwnProperty("mmo")) {
        if (this.$store.getters.data.mmo[this.layoutIndex] != null) {
          return this.$store.getters.data.mmo[this.layoutIndex];
        } else {
          return {};
        }
      }
      return {};
    },
    hdpouMMO(e) {
      var odds = this.mmo();
      var r = {};
      r["tn"] = 0;
      r["team"] = null;
      r["oxtn"] = 0;
      r["more"] = 0;

      if (odds != null) {
        if (odds.hasOwnProperty("hdp")) {
          if (odds["hdp"][e] != null) {
            r["hdp"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDP";
            });
            r["hdph"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDPH";
            });
            if (r["hdp"] ? r["hdp"].length : 0 > r["tn"]) {
              r["tn"] = r["hdp"].length;
              if (r["hdp"][0][8] != null && r["hdp"][0][8] != "0") {
                r["team"] = r["hdp"][0][7];
              } else {
                r["team"] = 2;
              }
            } else {
              r["hdp"] = null;
            }
            if (r["hdph"] ? r["hdph"].length : 0 > r["tn"]) {
              if (r["tn"] < r["hdph"].length) {
                r["tn"] = r["hdph"].length;
              }
              if (r["team"] == null) {
                if (r["hdph"][0][8] != null && r["hdph"][0][8] != "0") {
                  r["team"] = r["hdph"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["hdph"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ou")) {
          if (odds["ou"][e]) {
            r["ou"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OU";
            });
            r["ouh"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OUH";
            });
            if (r["ou"] ? r["ou"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ou"].length) {
                r["tn"] = r["ou"].length;
              }
              if (r["team"] == null) {
                if (r["ou"][0][8] != null && r["ou"][0][8] != "0") {
                  r["team"] = r["ou"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ou"] = null;
            }
            if (r["ouh"] ? r["ouh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ouh"].length) {
                r["tn"] = r["ouh"].length;
              }
              if (r["team"] == null) {
                if (r["ouh"][0][8] != null && r["ouh"][0][8] != "0") {
                  r["team"] = r["ouh"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ouh"] = null;
            }
          }
        }
      }
      return r;
    },
    hdpou(e) {
      var odds = this.odds();
      var r = {};
      r["tn"] = 0;
      r["team"] = null;
      r["oxtn"] = 0;
      r["more"] = 0;

      r["mmo"] = {};

      if (odds != null) {
        if (odds.hasOwnProperty("hdp")) {
          if (odds["hdp"][e] != null) {
            r["hdp"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDP";
            });
            r["hdph"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDPH";
            });
            if (r["hdp"] ? r["hdp"].length : 0 > r["tn"]) {
              r["tn"] = r["hdp"].length;
              if (r["hdp"][0][8] != null && r["hdp"][0][8] != "0") {
                r["team"] = r["hdp"][0][7];
              } else {
                r["team"] = 2;
              }
            } else {
              r["hdp"] = null;
            }
            if (r["hdph"] ? r["hdph"].length : 0 > r["tn"]) {
              if (r["tn"] < r["hdph"].length) {
                r["tn"] = r["hdph"].length;
              }
              if (r["team"] == null) {
                if (r["hdph"][0][8] != null && r["hdph"][0][8] != "0") {
                  r["team"] = r["hdph"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["hdph"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ou")) {
          if (odds["ou"][e]) {
            r["ou"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OU";
            });
            r["ouh"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OUH";
            });
            if (r["ou"] ? r["ou"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ou"].length) {
                r["tn"] = r["ou"].length;
              }
              if (r["team"] == null) {
                if (r["ou"][0][8] != null && r["ou"][0][8] != "0") {
                  r["team"] = r["ou"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ou"] = null;
            }
            if (r["ouh"] ? r["ouh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ouh"].length) {
                r["tn"] = r["ouh"].length;
              }
              if (r["team"] == null) {
                if (r["ouh"][0][8] != null && r["ouh"][0][8] != "0") {
                  r["team"] = r["ouh"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ouh"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("oxt")) {
          if (odds["oxt"][e]) {
            r["oxt"] = odds["oxt"][e].filter((v, i, r) => {
              return v[4] == "1X2";
            });
            r["oxth"] = odds["oxt"][e].filter((v, i, r) => {
              return v[4] == "1X2H";
            });
            if (r["oxt"] ? r["oxt"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oxt"].length) {
                r["tn"] = r["oxt"].length;
              }
              r["oxtn"] = 1;
            } else {
              r["oxt"] = null;
            }
            if (r["oxth"] ? r["oxth"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oxth"].length) {
                r["tn"] = r["oxth"].length;
              }
              r["oxtn"] = 1;
            } else {
              r["oxth"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("oe")) {
          if (odds["oe"][e]) {
            r["oe"] = odds["oe"][e].filter((v, i, r) => {
              return v[4] == "OE";
            });
            r["oeh"] = odds["oe"][e].filter((v, i, r) => {
              return v[4] == "OEH";
            });
            if (r["oe"] ? r["oe"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oe"].length) {
                r["tn"] = r["oe"].length;
              }
              r["oen"] = 1;
            } else {
              r["oe"] = null;
            }
            if (r["oeh"] ? r["oeh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oeh"].length) {
                r["tn"] = r["oeh"].length;
              }
              r["oehn"] = 1;
            } else {
              r["oeh"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ml")) {
          if (odds["ml"][e]) {
            r["ml"] = odds["ml"][e].filter((v, i, r) => {
              return v[4] == "ML";
            });
            r["mlh"] = odds["ml"][e].filter((v, i, r) => {
              return v[4] == "MLH";
            });
            if (r["ml"] ? r["ml"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ml"].length) {
                r["tn"] = r["ml"].length;
              }
              r["mln"] = 1;
            } else {
              r["ml"] = null;
            }
            if (r["mlh"] ? r["mlh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["mlh"].length) {
                r["tn"] = r["mlh"].length;
              }
              r["mlhn"] = 1;
            } else {
              r["mlh"] = null;
            }
          }
        }

        var head = this.head();
        var match = this.match();
        if (head[e] == undefined) {
          r["more"] = 0;
        } else {
          r["head"] = head[e][0];
          r["match"] = match[e];
          if (r["head"] != null) {
            r["more"] = head[e][0][7];
          }
          if (r["match"] != null) {
            r["league"] = this.league()[r["match"][1]][4];
          }
        }
      }

      // console.log("mmoMode: ", this.mmoMode)
      if (this.mmoMode) {
        r["mmo"] = this.hdpouMMO(e);
      }

      this.result = null;
      this.result = r;
      return r;
    },
    goToTab(mode) {
      if ([20, 40, 41, 42, 43, 47].includes(this.sportsType)) {
        this.emode = mode;
        return;
      }
      this.mode = mode;
    },
    checkOdds(e, t) {
      var result = false;

      switch (t) {
        case 1:
          e.forEach(value => {
            if (value[5] != null && value[5] != "" && value[7] != null && value[7] != "") {
              // result = this.menu3 != "parlay" ? true : value[8] == 1;
              result = true;
            }
          });
          break;
        case 2:
          e.forEach(value => {
            if (value[5] != null && value[5] != "" && value[6] != null && value[6] != "" && value[7] != null && value[7] != "") {
              // result = this.menu3 != "parlay" ? true : value[8] == 1;
              result = true;
            }
          });
          break;
        default:
          e.forEach(value => {
            if (value[5] != null && value[5] != "") {
              // result = this.menu3 != "parlay" ? true : value[8] == 1;
              result = true;
            }
          });
          break;
      }

      return result;
    },
    popupTV(e) {
      var canPlay = false;
      if (this.win.length < 4) {
        canPlay = true;
      } else {
        for (var n = 0; n < this.win.length; n++) {
          if (this.win[n].closed == true || this.win[n].name == e.match_id) {
            this.win.splice(n, 1);
            canPlay = true;
          }
        }
      }
      if (canPlay) {
        var w = 640; //screen.availWidth / 2;
        var h = 360; //screen.availHeight / 2;
        if (e.channelId) {
          var url = "/livetv?channel=" + e.channelId + "&match=" + e.matchId + "&sports=" + e.sportsId;
          var opts = "height=" + h + ",width=" + w + ",status=no,toolbar=no,menubar=no,location=no,resizable=yes";
          var w = window.open(url, e.matchId, opts);
          if (w) {
            this.$emit("popup-livetv");
          }
          var canAdd = true;
          for (var n = 0; n < this.win.length; n++) {
            if (this.win[n] == w) {
              canAdd = false;
              break;
            }
          }
          if (canAdd) {
            this.win.push(w);
            // console.log(this.win);
          }
        }
      } else {
        alert("You have exceeded your video streaming limit. Please close one if you wish to open another new session.");
      }
    }
  }
}
</script>